const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting){
              document.querySelector('.product-add-cart').classList.remove('sticky-btn');
          } else {
            document.querySelector('.product-add-cart').classList.add('sticky-btn'); 
          }
        })
      });
      
      let wrapper = document.querySelector('[data-product-container] .container');
      observer.observe(wrapper);
    }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
